import React from 'react';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  showMessage?: boolean;
  fullPage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message = 'Loading...',
  showMessage = true,
  fullPage = false,
}) => {
  const theme = useTheme();
  
  // Size mappings
  const sizeMap = {
    small: { spinner: 24, icon: 12, fontSize: 'body2' },
    medium: { spinner: 40, icon: 20, fontSize: 'body1' },
    large: { spinner: 60, icon: 30, fontSize: 'h6' },
  };
  
  const { spinner, icon, fontSize } = sizeMap[size];
  
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <CircularProgress
          size={spinner}
          thickness={4}
          sx={{
            color: theme.palette.primary.main,
          }}
        />
        <Typography
          variant="h6"
          component="span"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: theme.palette.primary.main,
            fontWeight: 'bold',
            fontSize: icon,
          }}
        >
          $
        </Typography>
      </Box>
      
      {showMessage && (
        <Typography 
          variant={fontSize as any} 
          sx={{ 
            color: theme.palette.text.secondary,
            mt: 1,
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
  
  if (fullPage) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundColor: `${theme.palette.background.default}CC`, // Semi-transparent background
          zIndex: 9999,
          backdropFilter: 'blur(3px)',
        }}
      >
        {content}
      </Box>
    );
  }
  
  return content;
};

export default LoadingSpinner; 